module.exports = __webpack_public_path__ + "img/system-net-8.3f2362cd.png";